"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dom = undefined;

var _utilsMain = require("./utils.main.js");

var _utilsString = require("./utils.string.js");

_utilsMain.main.dom = {};
/**
 * @module utils.DOM
 */

/**
 * A collection of static utility methods for using the DOM
 * @class utils.DOM
 */
/**
 * get the first element child of a node
 * @method getFirstChild
 * @static
 * @param {HTMLElement} el
 * @return {HTMLElement|null}
 */
_utilsMain.main.dom.getFirstChild = function getFirstChild(el) {
    var node;

    el = el[0] || el;

    node = el.firstChild;

    if ('firstElementChild' in el) return el.firstElementChild;

    if (!node) return null;
    while (node.nextSibling && node.nodeType != 1) {
        node = node.nextSibling;
    }if (node.nodeType == 1) return node;
    return null;
};

_utilsMain.main.dom.keyCodes = {
    UP: 38,
    DOWN: 40,
    ENTER: 13,
    ESC: 27,
    TAB: 9,
    PDOWN: 34,
    PUP: 33,
    RIGHT: 39,
    LEFT: 37
};

/**
 * returns the next sibling of an element that is and element
 * @method getNext
 * @static
 * @param {HTMLElement} el
 * @return {HTMLElement|null}
 */
_utilsMain.main.dom.getNext = function (el) {
    var node;

    el = el[0] || el;

    node = el.nextSibling;

    if ('nextElementSibling' in el) return el.nextElementSibling;

    while (node) {
        if (node.nodeType == 1) return node;
        node = node.nextSibling;
    }
    return null;
};

/**
 * return true if the first passed node is a descendant of the second passed node
 * or if it is the same node. Otherwise it return false.
 * @method isDescendantOf
 * @static
 *
 * @param {Node} descendant
 * @param {Node} ancestor
 * @return {Boolean}
 */
_utilsMain.main.dom.isDescendantOf = function (child, parent) {
    child = child[0] || child;
    parent = parent[0] || parent;

    while (child !== null && child !== parent) {
        child = child.parentNode;
    }

    return !!child;
};

/**
 * sets an element's html
 * @method setHTML
 * @static
 * @param {HTMLElement} el
 * @param {string}  html
 */
_utilsMain.main.dom.setHTML = function setHTML(el, html) {
    el = el[0] || el;

    if (arguments.length == 1) return el.innerHTML;

    el.innerHTML = html;
    return el;
};

/**
 * inserts a node after another node
 *
 * @method insertAfter
 * @static
 * @param {node} node
 * @param {node} target
 */
_utilsMain.main.dom.insertAfter = function (new_node, existing_node) {
    new_node = new_node[0] || new_node;
    existing_node = existing_node[0] || existing_node;

    if (existing_node.nextSibling) {
        existing_node.parentNode.insertBefore(new_node, existing_node.nextSibling);
    } else {
        existing_node.parentNode.appendChild(new_node);
    }
};

/**
 * removes a node from the DOM
 * @method remove
 * @static
 * @param {node} node
 */
_utilsMain.main.dom.remove = function remove(el) {
    el = el[0] ? el[0] : el.element ? el.element : el;

    if (el.parentNode) el.parentNode.removeChild(el);
};

!(function () {
    var addEvent, removeEvent;

    /**
     * adds an event listener to a dom element
     * @method addEvent
     * @static
     * @param {HTMLElement} el
     * @param {string}  type
     * @param {function} fn
     * @param {bool} phase
     */
    addEvent = _utilsMain.main.dom.addEvent = (function () {
        return 'addEventListener' in window ? function (el, type, fn, phase) {
            if (phase === undefined) phase = false;
            return el.addEventListener(type, fn, phase);
        } : function (el, type, fn) {
            return el.attachEvent('on' + type, fn);
        };
    })();

    /**
     * removes an event listener from a dom element
     * @method removeEvent
     * @static
     * @param {HTMLElement|*} el
     * @param {string}  type
     * @param {function} fn
     * @param {bool} phase
     */
    removeEvent = _utilsMain.main.dom.removeEvent = (function () {
        return 'removeEventListener' in window ? function (el, type, fn, phase) {
            if (phase === undefined) phase = false;
            return el.removeEventListener(type, fn, phase);
        } : function (el, type, fn) {
            return el.detachEvent('on' + type, fn);
        };
    })();

    /**
     * adds an event listener to a dom element, then removes it once it was executed once
     * @method addEventOnce
     * @static
     * @param {HTMLElement} el
     * @param {string}  type
     * @param {function} fn
     * @param {bool} phase
     */
    _utilsMain.main.dom.addEventOnce = function (el, type, fn, phase) {
        function once(e) {
            fn.call(el, e);
            removeEvent(el, type, once, !!phase);
        }

        addEvent(el, type, once, !!phase);
    };
}).call(undefined);

(function () {
    var testEl = document.createElement('div'),
        hasClass,
        addClass;

    /**
     * checks if an element has a specific class
     * @method hasClass
     * @static
     * @param {HTMLElement} el
     * @param {string}  className
     *
     * @return {Bool}
     */
    hasClass = _utilsMain.main.dom.hasClass = 'classList' in testEl ? function (element, className) {
        return element.classList.contains(className);
    } : function (element, className) {
        return new RegExp("\\b" + className + "\\b").test(element.className);
    };

    /**
     * adds a class to an element
     * @method addClass
     * @static
     * @param {HTMLElement} el
     * @param {string}  className
     */
    addClass = _utilsMain.main.dom.addClass = 'classList' in testEl ? function (element, className) {
        var names = className.split(' '),
            i,
            name;
        element = element[0] || element;

        for (i = 0; name = names[i]; i++) {
            element.classList.add(name);
        }
    } : function (element, className) {
        var classesArray = className.split(/\s+/),
            i;
        element = element[0] || element;

        if (!element) {
            throw new Error("Error in utils.js: addClass(): element can not be '" + element + "'. Calling function is: " + arguments.callee.caller);
        }

        for (i = 0; i < classesArray.length; i++) {
            if (!hasClass(element, classesArray[i])) {
                element.className += (element.className ? ' ' : '') + classesArray[i];
            }
        }
    };

    /**
     * removes a class from an element
     * @method removeClass
     * @static
     * @param {HTMLElement} el
     * @param {string}  className
     */
    _utilsMain.main.dom.removeClass = 'classList' in testEl ? function (element, className) {
        var names = className.split(' '),
            i,
            name;
        element = element[0] || element;
        for (i = 0; name = names[i]; i++) {
            element.classList.remove(name);
        }
    } : function (element, className) {
        var classesArray = className.split(/\s+/),
            classes,
            index,
            i,
            cls;

        element = element[0] || element;

        if (!element) {
            throw "Error in utils.js: addClass(): element can not be '" + element + "'. Calling function is: " + arguments.callee.caller;
        }

        classes = element.className.split(/\s+/);

        for (i = 0; cls = classesArray[i]; i++) {
            index = classes.indexOf(cls);
            if (index > -1) {
                classes.splice(index, 1);
            }
        }

        element.className = classes.join(' ');
    };

    _utilsMain.main.dom.toggleClass = 'classList' in testEl ? function (element, className) {
        element = element[0] || element;
        element.classList.toggle(className);
    } : function (element, cls) {
        element = element[0] || element;
        _utilsMain.main.dom[hasClass(element, cls) ? 'removeClass' : 'addClass'](element, cls);
    };
})();

/**
 * creates an element from a string
 *
 * If passed string contains multiple elements, will return an element containing them (can be configured using `args.tagName`)
 *
 * @method createElement
 *
 * @static
 * @param {string} html an HTML string
 * @param {object} [args] a list of attributes to set to the element. There also 2 special attributes you can use:
 *  @param {string} [args.tagName] if passed, will return an element with that tagName containing the template
 *  @param {string} [args.html] if passed will use this string as the inner HTML of the created element
 *
 * @returns {HTMLElement} the element created from this string
 */
_utilsMain.main.dom.createElement = function (html, args, use_query) {
    var frag, el, key;

    args = args || {};

    frag = document.createElement(args.tagName || 'div');

    frag.innerHTML = html;
    el = _utilsMain.main.dom.getFirstChild(frag);

    if (!el || args.tagName || _utilsMain.main.dom.getNext(el)) {
        el = frag;
    }

    if (args.html) el.innerHTML = args.html;

    for (key in args) {
        if (key == 'html' || key == 'tagName') continue;
        el.setAttribute(key, args[key]);
    }

    return use_query ? new _utilsMain.main.Query(el) : el;
};

/**
 * This method is used to transform a large subset of target types into an element
 *
 * @method toElement
 * @static
 * @param {*} target supports the following types:
 *
 *  * `Event` if passed an event, will return its target
 *  * `HTML` string if passed an HTML string, will use it as a template to create an element
 *  * `Selector` if passed a selector, will attempt to find it in the DOM
 *  * `Element` if passed an element, will return it
 *  * `Object` if passed an object, will check if it contains an `element` attribute that is an element and return it
 *
 * @param {object} [args] will be used as a parameter to pass to {{#crossLink "utils.DOM/createElement"}}{{/crossLink}}
 *
 * @returns {HTMLElement|null} found element or `null` in case no element was found
 */
_utilsMain.main.dom.toElement = function (target, args, use_query) {
    function wrap(el) {
        if (use_query) return new _utilsMain.main.Query(el);
        return el;
    }

    if (target.nodeType == 1) return wrap(target);

    if (target.element && target.element.nodeType == 1) return wrap(target.element);
    if (target.target && target.target.nodeType == 1) return wrap(target.target);

    if (typeof target != 'string') return use_query ? new _utilsMain.main.Query() : null;

    if (target[0] != '<') return wrap(document.querySelector(target));

    return _utilsMain.main.dom.createElement(target, args, use_query);
};

/**
 * isCssSupported - checks if given css property supported
 * @method isCssSupported
 * @static
 *
 * @param {String} property Javascript CSS property, in camel-case except
 * for the first letter which should be in lower case.
 *
 * @example
 * isCssSupported('textShadow');
 */
_utilsMain.main.dom.isCssSupported = (function () {
    var div = document.createElement('div'),
        vendors = ['Khtml', 'Ms', 'O', 'Moz', 'Webkit'],
        len = vendors.length;

    return function (property) {
        var i;

        // Check if W3C standard property is supported
        if (div.style[property] !== undefined) {
            return true;
        }

        // Standard property is not supported, add vendor prefix and test
        // for different vendors.
        property = property.replace(/^[a-z]/, function (val) {
            return val.toUpperCase();
        });

        for (i = 0; i < len; i++) {
            if (div.style[vendors[i] + property] !== undefined) {
                return true;
            }
        }

        return false;
    };
})();

/**
 * getStyle - gets computed style for specific element & specific CSS rule
 * @method getStyle
 * @static
 *
 * @param {Object} DOM element for which the computed style is sought
 * @param {String} CSS rule as (regular CSS syntax), e.g. font-size
 *
 * @example Chegg.utils.getStyle(Chegg.toolbar.element, 'z-index');
 */
_utilsMain.main.dom.getStyle = (function () {
    return function (element, cssRule) {
        var str = "";
        var element = element[0] || element;

        if (document.defaultView && document.defaultView.getComputedStyle) {
            str = document.defaultView.getComputedStyle(element, "").getPropertyValue(cssRule);
        } else if (element.currentStyle) {
            cssRule = cssRule.replace(/\-(\w)/g, function (strMatch, p1) {
                return p1.toUpperCase();
            });
            str = element.currentStyle[cssRule];
        }
        return str;
    };
})();

/**
 * gets the current styles of an element
 *
 * @method getStyles
 * 
 * @param {HTMLElement} target element
 * @param {array} props an array of style attributes
 *
 * @return {object} property->value map
 */
_utilsMain.main.dom.getStyles = (function () {
    function getStylesObject(element) {
        if (document.defaultView && document.defaultView.getComputedStyle) {
            return document.defaultView.getComputedStyle(element, "");
        } else {
            return element.currentStyle;
        }
    }

    function getStyle(obj, name) {
        if (obj.getPropertyValue) {
            return obj.getPropertyValue(name);
        } else {
            name = name.replace(/\-(\w)/g, function (strMatch, p1) {
                return p1.toUpperCase();
            });

            return obj[name];
        }
    }

    return function (element, props) {
        element = element[0] || element;

        var obj = getStylesObject(element),
            results = {},
            i,
            prop;

        for (i = 0; prop = props[i]; i++) {
            results[prop] = getStyle(obj, prop);
        }

        return results;
    };
})();

_utilsMain.main.dom.setStyles = function (element, styles, no_px) {
    var style;

    element = element[0] || element;

    for (style in styles) {
        if (!no_px && parseFloat(styles[style], 10) == styles[style]) {
            element.style[_utilsString.string.toCamel(style)] = styles[style] + 'px';
        } else {
            element.style[_utilsString.string.toCamel(style)] = styles[style];
        }
    }

    return element;
};

/**
 * @method getGlobalPosition
 * @static
 * @param {HTMLElement} element
 * @param {HTMLElement} [container=document.body]
 *
 * @return {object} {left, top}
 */
_utilsMain.main.dom.getGlobalPosition = (function () {
    return function (element, container) {
        var offsetParentElm = element,
            offsetParentOffsetLeft = 0,
            offsetParentOffsetTop = 0;

        if (!container) container = document.body;

        while (offsetParentElm && offsetParentElm != container) {
            offsetParentOffsetLeft += offsetParentElm.offsetLeft;
            offsetParentOffsetTop += offsetParentElm.offsetTop;
            offsetParentElm = offsetParentElm.offsetParent;
        }

        return {
            left: offsetParentOffsetLeft,
            top: offsetParentOffsetTop
        };
    };
})();

/**
 * returns a specific offset of an element related to a given target
 *
 * @method getOffset
 * @static
 * @param {string} direction can be either 'left' or 'top'
 * @param {HTMLElement} element
 * @param {HTMLElement} [target=document.body]
 *
 * @return {int}
 */
_utilsMain.main.dom.getOffset = function (dir, el, target) {
    el = el[0] || el;
    target = target[0] || target;

    var dir = dir.toLowerCase() == 'left' ? 'Left' : 'Top',
        target = target || document.body,
        parent = el.offsetParent,
        prop = 'offset' + dir,
        offset = el[prop];

    while (parent && parent != target && parent != document.body) {
        el = parent;
        parent = parent.offsetParent;
        offset += el[prop];
    }

    return offset;
};

/**
 * decodes html code into a string
 * @method htmlDecode
 * @static
 * @param {string} html
 * @return {string}
 */
_utilsMain.main.dom.htmlDecode = function (html) {
    var tarea = document.createElement('textarea');
    tarea.innerHTML = html;

    document.body.appendChild(tarea);
    document.body.removeChild(tarea);

    return tarea.value;
};

/**
 * a shorthand for querySelectorAll
 * @method query
 * @static
 * @param {string} selector
 * @param {HTMLElement} [scope=document]
 *
 * @return {array}
 */
_utilsMain.main.dom.query = function (selector, scope) {
    if (scope) {
        return scope.querySelectorAll(selector);
    } else {
        return document.querySelectorAll(selector);
    }
};

_utilsMain.main.dom.statusBar = function (used, max, text, customScale) {
    var scale = customScale ? customScale : 180,
        progress = scale / max * used,
        html,
        left = (max - used).toString();

    html = '<div class="status-bar">' + '<div class="bar fleft" style="width: ' + scale + 'px">' + '<div class="progress" style="width: ' + progress + 'px"></div>' + '</div>' + '<p class="fleft">' + text.replace('%d', '<strong>' + _utilsString.string.formatNumber(left) + '</strong>') + '</p>' + '</div>';

    return html;
};

_utilsMain.main.dom.getStyleSheetById = function (elementId) {
    var i, styleSheet;

    // Iterate from the last stylesheet to the first, because most probably
    // searched stylesheet is in the end of document's styleSheets list, if
    // it's style element was just appended.
    for (i = document.styleSheets.length - 1; i >= 0; i--) {
        styleSheet = document.styleSheets[i];
        if (styleSheet.ownerNode.id === elementId) {
            return styleSheet;
        }
    }

    return null;
};

/**
 * finds the first element in an element's parent chain than matches a specific class
 *
 * @method delegate
 * @static
 * @param {HTMLElement} el
 * @param {string}  className
 * @param {HTMLElement} [stop=document.body]
 *
 * @return {HTMLElement|null}
 */
_utilsMain.main.dom.delegate = function (el, name, stop) {
    if (!el) return null;
    stop = stop || document.body;

    while (el && el != stop && el != document.body) {
        if (_utilsMain.main.dom.hasClass(el, name)) return el;
        el = el.parentNode;
    }

    return null;
};

/**
 * insert an element into a target element, before the first element that has a larger value of a specific attribute
 * @method insertByProp
 * @static
 * @param {HTMLElement} el
 * @param {string}  property
 * @param {HTMLElement} parent
 *
 * @example
 * a note list has a list of elements that have a data-time attribute containing creation time
 *
 *     var note = document.createElement('li');
 *     note['data-time'] = Date.now()-1000 * 60 * 60 *3; //note that was created 3 hours ago
 *
 *     utils.dom.insertByProp(note,'data-time',note_list); //will insert the note after the latest note that was created earlier more than 3hrs ago
 *
 * @return {int} index of inserted element
 */
_utilsMain.main.dom.insertByProp = function (el, prop, parent) {
    el = el[0] || el;
    parent = parent[0] || parent;

    var next = parent.firstChild,
        el_value = +el.getAttribute(prop),
        counter = 0,
        value;

    while (next) {
        value = next.getAttribute ? next.getAttribute(prop) : null;

        if (value != null && +value > el_value) break;

        next = next.nextSibling;
        counter++;
    }

    if (next) {
        parent.insertBefore(el, next);
        return counter;
    } else {
        parent.appendChild(el);
        return parent.childNodes.length - 1;
    }
};

/**
 * returns a collection of elements based on a selector map
 * @method getElements
 * @static
 *  @param {HTMLElement} element a source element to search
 *  @param {Object}  map     a map of name->selector pairs
 *
 * @example
 *
 *      utils.dom.getElements(element, {
 *          header: '.header',
 *          footer: '.footer'
 *      });
 *
 *  will return an object with header and footer matching these selectors under `element`
 *
 * @return {Object} a map of name->element based on selector map
 */
_utilsMain.main.dom.getElements = function (element, map, use_query) {
    var obj = {},
        name;

    for (name in map) {
        if (_utilsMain.main.has(map, name)) {
            if (use_query) obj[name] = _utilsMain.main.$(map[name]);else obj[name] = element.querySelector(map[name]);
        }
    }return obj;
};

(function () {
    var el = document.createElement('div'),
        matches = 'webkitMatchesSelector' in el ? 'webkitMatchesSelector' : 'mozMatchesSelector' in el ? 'mozMatchesSelector' : 'msMatchesSelector' in el ? 'msMatchesSelector' : 'matchesSelector' in el ? 'matchesSelector' : null;

    /**
     * a cross-browser method for checking if an element mathces a specific selector
     * @method matchesSelector
     * @static
     * @param {HTMLElement} el
     * @param {String}  selector
     *
     * @return {bool}
     */
    _utilsMain.main.dom.matchesSelector = matches ? function (el, selector) {
        if (!el[matches]) return false;
        return el[matches](selector);
    } : function (el, selector) {
        var collection = document.querySelectorAll(selector);
        return collection.indexOf(el) > -1;
    };
}).call(undefined);

_utilsMain.main.dom.getEventKey = function getEventKey(e) {
    var names = {
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        13: 'enter',
        27: 'esc',
        9: 'tab'
    },
        str;

    if (!e.keyCode) return '';

    str = names[e.keyCode] || _utilsString.string.trim(String.fromCharCode(e.keyCode));

    str = str.replace(/\W/g, '');

    if (!str) return '';

    if (e.shiftKey) str = 'shift+' + str;
    if (e.altKey) str = 'alt+' + str;
    if (e.ctrlKey) str = 'ctrl+' + str;

    return str.toLowerCase();
};

_utilsMain.main.dom.append = function (parent, child) {
    parent = parent.element || parent;
    child = child.element || child;

    parent.appendChild(child);

    return parent;
};

_utilsMain.main.dom.appendStyles = function (list) {
    var head = document.head,
        i,
        link;

    for (i = 0; i < list.length; ++i) {
        link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = list[i];
        head.appendChild(link);
    }
};

_utilsMain.main.dom.appendBefore = function (child, ref) {
    var parent;

    child = child.element || child[0] || child;
    ref = ref.element || ref[0] || ref;

    parent = ref.parentNode;

    parent.insertBefore(child, ref);
};

_utilsMain.main.dom.appendAfter = function (child, ref) {
    var parent;

    child = child.element || child;
    ref = ref.element || ref;

    child = child.element || child[0] || child;
    ref = ref.element || ref[0] || ref;

    parent = ref.parentNode;

    if (ref == parent.lastChild) {
        parent.appendChild(child);
    } else {
        parent.insertBefore(child, ref.nextSibling);
    }
};

_utilsMain.main.dom.getCoords = function (element) {
    var pos = _utilsMain.main.dom.getGlobalPosition(element),
        scroll;

    while (element = element.parentNode) {
        scroll = element.scrollTop;
        if (scroll) pos.top -= scroll;

        scroll = element.scrollLeft;
        if (scroll) pos.left -= scroll;
    }

    pos.x = pos.left;
    pos.y = pos.top;

    return pos;
};

(function () {
    function preventIE(event) {
        var target = event.target,
            preventSelection = true;
        // Stop on the most inner element with selectable or unselectable class.
        while (target !== null) {
            if (_utilsMain.main.hasClass(target, "selectable")) {
                preventSelection = false;
                break;
            } else if (_utilsMain.main.hasClass(target, "unselectable")) {
                break;
            }
            target = target.parentNode;
        }
        if (preventSelection) {
            event.preventDefault();
        }
    }

    function prevent(e) {
        e.preventDefault();
    }

    _utilsMain.main.dom.disableSelection = function (element) {
        _utilsMain.main.dom.addClass(element, 'no-selection');

        // Prevent iPhone's touchmove default behavior so it will not drag the
        // whole browser's screen. As required by iScroll - http://cubiq.org/iscroll
        element.addEventListener('touchmove', prevent, false);

        // IE9 doesn't support "user-select: none" CSS property.
        // So use selectstart event instead to disable user selection.
        if (_utilsMain.main.agent.isIE9) {
            element.addEventListener("selectstart", preventIE, false);
        }
    };

    _utilsMain.main.dom.enableSelection = function (element) {
        _utilsMain.main.dom.removeClass(element, 'no-selection');

        // Prevent iPhone's touchmove default behavior so it will not drag the
        // whole browser's screen. As required by iScroll - http://cubiq.org/iscroll
        element.removeEventListener('touchmove', prevent, false);

        // IE9 doesn't support "user-select: none" CSS property.
        // So use selectstart event instead to disable user selection.
        if (_utilsMain.main.agent.isIE9) {
            element.removeEventListener("selectstart", preventIE, false);
        }
    };
})();

_utilsMain.main.dom.getElementSize = function getElementSize(el) {
    var parent = el.parentNode,
        width = el.offsetWidth,
        height = el.offsetHeight;

    if (!width && !height) {
        document.body.appendChild(el);
        _utilsMain.main.dom.addClass(el, 'calculate-size');
        width = el.offsetWidth;
        height = el.offsetHeight;
        _utilsMain.main.dom.removeClass(el, 'calculate-size');
        parent.appendChild(el);
    }

    return {
        width: width,
        height: height
    };
};

_utilsMain.main.dom.appendStyles = function (list) {
    var head = document.head,
        i,
        link;

    for (i = 0; i < list.length; ++i) {
        link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = list[i];
        head.appendChild(link);
    }
};

var dom = exports.dom = _utilsMain.main.dom;


//////////////////
// WEBPACK FOOTER
// ./~/ereader-core/dist/utils.dom.js
// module id = 236
// module chunks = 0